import { API } from "actions/api";
import NotificationManager from "utils/notifications";

const GENERIC_ERROR = "Something went wrong. Please try again.";

export const setMFAOptions = body => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa",
      method: "PUT",
      body
    });
    return result;
  } catch (error) {
    console.error("setMFAOptions:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const fetchMFAOptions = () => async dispatch => {
  try {
    const MFAOptions = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa",
      method: "GET"
    });
    return MFAOptions;
  } catch (error) {
    console.error("fetchMFAOptions:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const verifyPhoneNumber = body => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa/phone-verify",
      method: "PUT",
      body
    });
    return result;
  } catch (error) {
    console.error("verifyPhoneNumber:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const sendCodeToContactMethod = (means, body) => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: `patient_portal/mobile/mfa/send-code/${means}`,
      method: "POST",
      body
    });
    return result;
  } catch (error) {
    console.error("sendCodeToContactMethod:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const updateMFAPhone = body => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa/phone",
      method: "PUT",
      body
    });
    return result;
  } catch (error) {
    console.error("updateMFAPhone:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const resendCodeToContactMethod = (means, body) => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: `patient_portal/mobile/mfa/resend-code/${means}`,
      method: "POST",
      body
    });
    return result;
  } catch (error) {
    console.error("resendCodeToContactMethod:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};
